import React, { useState } from "react";

function Footer() {
    return (
        <footer>
            <p>Make by Alan G. Alonso</p>
        </footer>
    );
}

export default Footer;
